import {
    DomainExplorerContent,
    GroupsExplorerContent,
    ExploreLayout,
} from '@backstage-community/plugin-explore';

export const ExplorePage = () => {
    return (
        <ExploreLayout
            title="Discover the Cegid Platform"
            subtitle="Navigate domains and groups to find services, APIs, and teams"
        >
            <ExploreLayout.Route path="domains" title="Domains">
                <DomainExplorerContent />
            </ExploreLayout.Route>
            <ExploreLayout.Route path="groups" title="Groups">
                <GroupsExplorerContent />
            </ExploreLayout.Route>
        </ExploreLayout>
    );
};

export const explorePage = <ExplorePage />;